module.exports = __webpack_public_path__ + "5b2f91ca5491c3a572fa66b938ab7dec.jpg";